import React from 'react';
import PropTypes from 'prop-types';
import { Label } from './style';

var CheckboxLabel = function CheckboxLabel(props) {
  return React.createElement(Label, null, props.tag);
};

CheckboxLabel.propTypes = {
  tag: PropTypes.string.isRequired
};
export default CheckboxLabel;